<!-- 隔开的input -->
<template>
  <div class="separete" :class="{ disabled: disabled, fouce: isFouce }">
    <el-input-number
      size="small"
      :disabled="disabled || leftOption.disabled"
      v-model="leftData"
      :min="leftOption.min"
      :max="leftOption.max"
      :precision="leftOption.precision"
      :controls="false"
      :placeholder="leftOption.placeholder"
      @change="change(0)"
      style="width:48%;"
      @focus="isFouce = true"
      @blur="isFouce = false"
    ></el-input-number>
    <!-- <input v-model="leftData" :class="{disabled: disabled}" class="paperview-input-text" placeholder="请填写具体比例" @change="change" /> -->
    <span style="color: #C8C9CC;width:5px">/</span>
    <!-- <input v-model="rightData" :class="{disabled: disabled}" class="paperview-input-text" style="text-align:right" placeholder="请填写具体金额" @change="change" /> -->
    <el-input-number
      size="small"
      :disabled="disabled || rightOption.disabled"
      v-model="rightData"
      :min="rightOption.min"
      :precision="rightOption.precision"
      :controls="false"
      :placeholder="rightOption.placeholder"
      @change="change(1)"
      style="width:48%"
      @focus="isFouce = true"
      @blur="isFouce = false"
    ></el-input-number>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftData: 0,
      rightData: 0,
      isFouce: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Number,
      default() {
        return 0;
      },
    },
    right: {
      type: Number,
      default() {
        return 0;
      },
    },
    maxLeft: {
      type: Number,
      default() {
        return 100;
      },
    },
    maxRight: {
      type: Number,
      default() {
        return 0;
      },
    },
    haveMax: {
      type: Boolean,
      default: false,
    },
    leftOption: {
      type: Object,
      default: () => {
        return {
          min: 0,
          precision: 2,
          placeholder: "请填写具体比例",
          disabled: false,
        };
      },
    },
    rightOption: {
      type: Object,
      default: () => {
        return {
          min: 0,
          precision: 4,
          placeholder: "请填写具体金额",
          disabled: false,
        };
      },
    },
    autoCalculation: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    left: {
      handler(val, oldVal) {
        this.leftData = val;
      },
      immediate: true,
    },
    right: {
      handler(val, oldVal) {
        this.rightData = val;
      },
      immediate: true,
    },
  },
  methods: {
    change(type) {
      if (this.autoCalculation) {
        let changeRatio = type == 0; // 改变的是否为比例

        if (changeRatio) {
          this.rightData =
            ((this.maxRight * this.leftData) / 100).toFixed(2) * 1;
          if (this.leftData > this.maxLeft) {
            this.leftData = this.maxLeft;
            this.rightData =
              ((this.maxRight * this.leftData) / 100).toFixed(2) * 1;
          }
        } else {
          this.leftData =
            ((this.rightData / this.maxRight) * 100).toFixed(2) * 1;
          if (this.leftData > this.maxLeft) {
            this.leftData = this.maxLeft;
            this.rightData =
              ((this.maxRight * this.leftData) / 100).toFixed(2) * 1;
          }
        }
      }
      this.$emit("change", this.leftData, this.rightData);
    },
  },
};
</script>

<style lang="scss" scoped>
.separete {
  // width: 290px;
  height: 33px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  padding: 0px 0px 2px;
}
.disabled {
  background-color: #f5f7fa;
  color: #c0c4cc !important;
}
// .paperview-input-text {
//   border: 0;
//   outline: none;
//   // width: calc(48% - 5px);
//   color: #606266;
//   &:focus {
//     border-bottom: 1px solid #286ab4;
//   }
// }
// input::-webkit-input-placeholder {
//   /* placeholder颜色  */
//   color: #aab2bd;
//   /* placeholder字体大小  */
//   // font-size: 12px;
//   /* placeholder位置  */
//   // text-align: right;
// }

/deep/.el-input__inner {
  border: 0px;
}
.fouce {
  border: 1px solid #286ab4;
}
</style>
